import dashboard from "./menu/dashboard";
import administrator from "./menu/administrator";
import rolePermission from "./menu/rolePermission";
import match from "./menu/match";
import company from "./menu/company";
import senior from "./menu/senior";
import master from "./menu/master";
import agent from "./menu/agent";
import player from "./menu/player";
import transaction from "./menu/transaction";
import balanceReport from "./menu/balanceReport";
import betSetting from "./menu/betSetting";
import live from "./menu/live";

export default [
  ...dashboard,
  ...administrator,
  ...rolePermission,
  ...match,
  ...live,
  ...company,
  ...senior,
  ...master,
  ...agent,
  ...player,
  ...transaction,
  ...balanceReport,
  ...betSetting,
]
